import { JOB_STATUSES_ENUM } from 'app/types/enums/jobStatuses';

import { getJobStatusTextClassName } from './helpers/getJobStatusTextClassName';

type TProps = {
  status: string;
  removed?: boolean;
  testid?: string;
  className?: string;
};

export const JobStatusText = ({ status, removed, testid, className = 'status' }: TProps) => {
  const text = removed ? 'Deleted' : JOB_STATUSES_ENUM[status as keyof typeof JOB_STATUSES_ENUM];
  const colorClass = getJobStatusTextClassName(text);

  return (
    <p className={`font-medium ${colorClass} ${className}`.trim()} data-testid={testid}>
      {text}
    </p>
  );
};
